import { gql } from '@apollo/client'

// This is the same for public and resigned public profiles
export default gql`
  fragment Education on Education {
    id
    level
    title
    university
    country
    isHighestEducation
    officialDegreeName
    date
    grade
  }
`
